// Re-export from the shared WalletProvider so all components
// consume the same singleton state instance.
export { useWallet } from '@/providers/wallet-provider'

